import {Component, inject, input, signal} from '@angular/core';
import {Dropdown} from "../../../../components/dropdown/dropdown";
import {MultiDropdown} from "../../../../components/multi-dropdown/multi-dropdown";
import {TodoState} from '../../../../../api';
import {FormControl} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'elcia-todo-state-dropdown',
  imports: [
    Dropdown,
    MultiDropdown
  ],
  templateUrl: './todo-state-dropdown.html',
  styleUrl: './todo-state-dropdown.scss',
})
export class TodoStateDropdown {

  isMulti = input(false);
  control = input.required<FormControl>();

  translateService = inject(TranslateService);

  states = signal([
    {
      id: TodoState.ACTIVE,
      label: this.translateService.instant('todo-state.active'),
    } as TodoStateModel,
    {
      id: TodoState.ARCHIVED,
      label: this.translateService.instant('todo-state.archived'),
    } as TodoStateModel,
  ])
}

interface TodoStateModel {
  id: TodoState;
  label: string;
}
